
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gestion-inscription",
      function () {
        return require("private-next-pages/gestion-inscription.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gestion-inscription"])
      });
    }
  